import { Footer } from "./Footer";
import { Sidebar } from "./Sidebar";
import { useLocation } from "react-router-dom";

export const SecondLayout = ({ children }) => {
    const location = useLocation();
    const path = location.pathname;

    // Determine if footer should be shown
    const shouldShowFooter =
        path !== "/activity" &&
        path !== "/account" &&
        path !== "/crypto-address" &&
        path !== "/transaction-detail" &&
        path !== "/profile" &&
        path !== "/cards" &&
        path !== "/plans" &&
        path !== "/investment-dashboard";

    const getBackgroundStyles = (path) => {
        if (path === "/cards") {
            return {
                // backgroundImage: "url('./images/store/notification_bg.png')",
                // backgroundRepeat: "no-repeat",
                // backgroundPosition: "0px 0px",
                // backgroundSize: "cover",
                // backgroundColor: "#000000",
            };
        }

        if (path === "/activity") {
            return {
                backgroundImage: "url('./images/store/recent_activity_bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: "contain",
                backgroundColor: "#000000",
            };
        }

        if (
            path === "/crypto-address" ||
            path === "/account" ||
            path === "/profile" ||
            path === "/investment-dashboard"
        ) {
            return {
                backgroundImage: "url('./images/store/notification_bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: "contain",
                backgroundColor: "#000000",
            };
        }

        if (path === "/transaction-detail") {
            return {
                backgroundImage:
                    "url('./images/store/transaction_detail_bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: "cover",
                backgroundColor: "#000000",
            };
        }

        return {
            backgroundColor: "#141414", // Default background color
        };
    };

    return (
        <div
            className="App md:container md:my-auto"
            style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
            }}
        >
            <div
                className="w-100 mx-auto desktop-border position-relative"
                style={getBackgroundStyles(path)}
            >
                <Sidebar />
                <div
                    className={`page-content ${
                        shouldShowFooter ? "footer-clear" : ""
                    }`}
                >
                    {children}
                </div>
                {shouldShowFooter && <Footer />}
            </div>
        </div>
    );
};
